import React from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import AppRouter from './routes/AppRouter';
import Header from './components/Header';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';
import Analytics from './components/Analytics';
import ChatBotWidget from './components/ChatBot/ChatBotWidget';
import WhatsAppWidget from './components/WhatsApp/WhatsAppWidget';
import { AuthProvider } from './context/AuthContext';
import { CurrencyProvider } from './context/CurrencyContext';

function AppContent() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  return (
    <div className="min-h-screen">
      {!isAdminRoute && <Header />}
      <AppRouter />
      {!isAdminRoute && <Footer />}
      {!isAdminRoute && <CookieConsent />}
      {!isAdminRoute && <Analytics />}
      {!isAdminRoute && <WhatsAppWidget />}
      {!isAdminRoute && <ChatBotWidget />}
    </div>
  );
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <CurrencyProvider>
        <AuthProvider>
          <Router>
            <AppContent />
          </Router>
        </AuthProvider>
      </CurrencyProvider>
    </I18nextProvider>
  );
}

export default App;
